import { mergeKeyWith } from '../../../common/query'

const getOrgformKodeKeys = () => {
  const keys = {
    all: [{ entity: 'orgform-kode' }] as const,
    get: (orgNr?: string, tilsynsobjektId?: string) =>
      mergeKeyWith(keys.all, { tilsynsobjektId, orgNr }),
  } as const

  return keys
}
const orgformKodeKeys = getOrgformKodeKeys()

export type OrgformKodeKeys = typeof orgformKodeKeys

export { orgformKodeKeys }
